<template>
    <div>
        <section>
            <v-card-actions>
                <router-link to="/courses">
                    <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Back </v-btn>
                </router-link>
            </v-card-actions>
            <h1>{{ card.title }}</h1>
            <!-- Título y subtítulo             
            <h3>{{ card.subtitle }}</h3>-->
            <v-divider></v-divider>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <v-img class="align-end text-white" contain :style="{ 'max-width': '180vh', 'max-height': '50vh' }" :src="getImageSrc(card.images)"></v-img>
                </v-col>
            </v-row>
            <v-row>                
                <v-col cols="12" md="6" lg="12">
                    <p style="font-size: 50px; color: rgb(15, 135, 201);"><b>________________________________________________</b></p>
                    <!---->
                    
                    <details @click="mostrarAdjuntosCategories(6)" open>
                        <summary id="cat6">
                            <p><b>Elearning</b></p>
                        </summary>
                        <div>
                            <p>
                                <b>Elearning</b><br>
                                <ul>
                                    <li>
                                        UNCAC Model Academic Course:
                                        <a @click="descargarCategory(6, 'UNCAC_Academic_Course_English.pdf')" target="_blank" style="text-decoration: underline; color: var(--v-anchor-base);">{{ 'EN' }} </a> - 
                                        <a @click="descargarCategory(6, 'UNCAC_Academic_Course_French.pdf')" target="_blank" style="text-decoration: underline; color: var(--v-anchor-base);">{{ 'FR' }} </a> - 
                                        <a @click="descargarCategory(6, 'UNCAC_Academic_Course_Spanish.pdf')" target="_blank" style="text-decoration: underline; color: var(--v-anchor-base);">{{ 'ES' }} </a>
                                    </li>
                                    <li>
                                        <a href="https://track.unodc.org/track/en/resources-by-thematic-area/education-and-youth-empowerment.html" target="_blank">Education on TRACK portal</a>
                                    </li>
                                    <li>
                                        <a href="https://www.unodc.org/e4j/" target="_blank">Education for Justice (E4J)</a>
                                    </li>
                                    <li>
                                        <a href="https://www.unodc.org/e4j/en/tertiary/anti-corruption.html" target="_blank">E4J University Modules on Anti-Corruption</a>
                                    </li>
                                    <li>
                                        <a href="https://www.unodc.org/e4j/en/tertiary/integrity-ethics.html" target="_blank">E4J University Modules on Integrity and Ethics</a>
                                    </li>
                                    <li>
                                        <a href="https://www.unodc.org/e4j/en/integrity-ethics/teaching-guide/index.html" target="_blank">E4J Teaching Guide on Integrity and Ethics</a>
                                    </li>
                                    <li>
                                        <a href="https://e4jlearning.org/" target="_blank">E4J Online Course for Lecturers on How to Implement E4J in your University</a>
                                    </li>
                                    <li>Library of educational resources on Anti-Corruption</li>
                                    <li>Online library of educational resources on Integrity and Ethics</li>
                                    <li>
                                        <a href="https://www.unodc.org/elearning/en/courses/public.html" target="_blank">UNODC Anti-Corruption E-learning Courses</a> - 
                                        see full catalogue <a @click="descargarCategory(6, 'UNODC_Global_eLearning_Courses_Catalogue_WEB.pdf')" target="_blank" style="text-decoration: underline; color: var(--v-anchor-base);">{{ 'here' }} </a>
                                    </li>
                                    <li><a href="http://www.thefightagainstcorruption.org/" target="_blank">UNODC/UNGC Video E-learning Modules for the private sector</a></li>
                                    <li><a href="https://www.un-anticorruption-learn.org/" target="_blank">The Global Anti-Corruption Training Platform</a></li>
                                </ul>
                            </p>
                        </div>
                    </details>
                </v-col>
            </v-row>
        </section>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {            
            nombresAdjuntos: [], nombresAdjuntos2: [], nombresAdjuntos3: [], nombresAdjuntos4: [], nombresAdjuntos5: [], nombresAdjuntos6: [], nombresAdjuntos7: [],
            nombresAdjuntos8: [], nombresAdjuntos9: [], nombresAdjuntos10: [], nombresAdjuntos11: [], nombresAdjuntos12: [], nombresAdjuntos13: [], nombresAdjuntos14: [],
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                additionalInfo2: '',
                images: [],
                chip: [],
            },
            cards: [
                {
                    id: 1,
                    title: 'CORRUPTION',
                    subtitle: 'UNODC',
                    category: '<p><b></p></b>'+
                        '<ul>'+
                            '<li><a href="#cat1" style="text-decoration: none;">1.1.	United Nations Convention against Corruption -UNCAC</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat1_1" style="text-decoration: none;">1.1.1. The Conference of the States Parties to UNCAC and the UNCAC Implementation Review Mechanism</a></li>'+
                                    '<li><a href="#cat1_2" style="text-decoration: none;">1.1.2. Country Profile Database</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat2" style="text-decoration: none;">1.2.	Prevention of Corruption and Fair Public Management</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat2_1" style="text-decoration: none;">1.2.1. Prevention of Corruption</a></li>'+
                                    '<li><a href="#cat2_2" style="text-decoration: none;">1.2.2. Anti-Corruption Strategies</a></li>'+
                                    '<li><a href="#cat2_3" style="text-decoration: none;">1.2.3. Public Procurement and Fair Public Management</a></li>'+
                                    '<li><a href="#cat2_4" style="text-decoration: none;">1.2.4. Strengthening the Integrity of the Public Sector</a></li>'+
                                    '<li><a href="#cat2_5" style="text-decoration: none;">1.2.5. Strengthened Transparency and Public Reporting</a></li>'+
                                    '<li><a href="#cat2_6" style="text-decoration: none;">1.2.6. The Role of Civil Society</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat7" style="text-decoration: none;">1.3.	Criminalization and Law Enforcement</a></li>'+
                            '<li><a href="#cat3" style="text-decoration: none;">1.4.	International Cooperation</a></li>'+
                            '<li><a href="#cat4" style="text-decoration: none;">1.5. Asset Recovery</a></li>'+
                            '<li><a href="#cat5" style="text-decoration: none;">1.6. Thematic Areas</a></li>'+
                            '<ul>'+
                                    '<li><a href="#cat5_1" style="text-decoration: none;">1.6.1. Climate Change</a></li>'+
                                    '<li><a href="#cat5_2" style="text-decoration: none;">1.6.2. Crimes that affect the environment</a></li>'+
                                    '<li><a href="#cat5_3" style="text-decoration: none;">1.6.3. Education</a></li>'+
                                    '<li><a href="#cat5_4" style="text-decoration: none;">1.6.4. Gender</a></li>'+
                                    '<li><a href="#cat5_5" style="text-decoration: none;">1.6.5. Health</a></li>'+
                                    '<li><a href="#cat5_6" style="text-decoration: none;">1.6.6. Human Rights</a></li>'+
                                    '<li><a href="#cat5_7" style="text-decoration: none;">1.6.7. International Investments</a></li>'+
                                    '<li><a href="#cat5_8" style="text-decoration: none;">1.6.8. Judicial Integrity</a></li>'+
                                    '<li><a href="#cat5_9" style="text-decoration: none;">1.6.9. Parliaments</a></li>'+
                                    '<li><a href="#cat5_10" style="text-decoration: none;">1.6.10. Private Sector</a></li>'+
                                    '<li><a href="#cat5_11" style="text-decoration: none;">1.6.11. Sports</a></li>'+
                                    '<li><a href="#cat5_12" style="text-decoration: none;">1.6.12. Supreme Audit Institutions</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat6" style="text-decoration: none;">1.7. Elearning, databases and libraries</a></li>'+
                        '</ul>',
                    additionalInfo: 'Additional Info',
                    additionalInfo2: 'Corruption is a complex social, political and economic phenomenon that affects all countries. Corruption undermines '+
                    'democratic institutions, slows economic development and contributes to governmental instability. Corruption attacks the foundation of democratic'+
                    ' institutions by distorting electoral processes, perverting the rule of law and creating bureaucratic quagmires whose only reason for existing is '+
                    'the soliciting of bribes. Economic development is stunted because foreign direct investment is discouraged and small businesses within the country '+
                    'often find it impossible to overcome the "start-up costs" required because of corruption.',
                    description: '',                    
                    images: ['1.png'],                    
                    chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                },
                {
                    id: 2,
                    title: 'Crime Prevention and Criminal Justice',
                    subtitle: 'UNODC',
                    category: '<p><b></p></b>'+
                        '<ul>'+
                            '<li>0. GENERAL TOOLS ON CRIME PREVENTION AND CRIMINAL JUSTICE</li>'+
                            '<li>1. STATSTICS AND SURVEYS</li>'+
                            '<li>2. CRIME PREVENTION</li>'+
                            '<li>3. POLICE REFORM</li>'+
                                '<ul>'+
                                    '<li>3.1 STANDARDS AND NORMS</li>'+
                                    '<li>3.2 PUBLICATIONS/li>'+
                                    '<li>3.3 MULTIMEDIA</li>'+
                                '</ul>'+
                            '<li>4. LEGAL AID</li>'+
                                '<ul>'+
                                    '<li>4.1 Legal Framework</li>'+
                                    '<li>4.2 UNITED NATIONS RESOLUTIONS/li>'+
                                    '<li>4.3 PRACTICAL GUIDANCE</li>'+
                                    '<li>4.4 SURVEYS AND DATA</li>'+
                                    '<li>4.5 MULTIMEDIA</li>'+
                                '</ul>'+
                            '<li>5. GENDER IN CRIMINAL JUSTICE SYSTEM</li>'+
                                '<ul>'+
                                    '<li>5.1 ELEARNING</li>'+
                                '</ul>'+
                            '<li>6. JUSTICE FOR CHILDREN</li>'+
                                '<ul>'+
                                    '<li>6.1 CHILD VICTIMS AND WITNESSES OF CRIME</li>'+
                                    '<li>6.2 VIOLENCE AGAINST CHILDREN/li>'+
                                    '<li>6.3 VICTIM SUPPORT</li>'+
                                '</ul>'+
                            '<li>7. PRISON REFORM AND ALTERNATIVES TO IMPRISONMENT</li>'+
                                '<ul>'+
                                    '<li>7.1 UNITED NATIONS STANDARDS AND NORMS</li>'+
                                    '<li>7.2 UNITED NATIONS GUIDANCE DOCUMENTS RELATED TO INCARCERATION/li>'+
                                    '<li>7.3 ALTERNATIVES TO IMPRISONMENT</li>'+
                                    '<li>7.4 PRISON MANAGEMENT</li>'+
                                    '<ul>'+
                                        '<li>7.4.1 TOOLKIT ON THE NELSON MANDELA RULES</li>'+
                                        '<li>7.4.2 PRISON MANAGEMENT STRATEGIES AND CORE PRACTICES/li>'+
                                        '<li>7.4.3 SPECIAL CATEGORIES OF PRISONERS</li>'+
                                        '<li>7.4.4 PRISON HEALTH</li>'+
                                        '<li>7.4.5 REHABILITATION AND SOCIAL REINTEGRATION</li>'+
                                    '</ul>'+
                                '</ul>'+
                        '</ul>',
                    additionalInfo: 'Additional Info',
                    additionalInfo2: 'UNODC develops tools for stakeholders to assist States in the implementation of the UN standards and norms. They include a variety of handbooks, training curriculums and model laws which provide guidance to United Nations agencies, governments and individuals at each stage of criminal justice reform'+
                                    'An overview of all the handbooks and manuals that the Justice Section develops is available in English, French, Spanish,Russian',
                    description: '',
                },
                {
                    id: 3,
                    title: 'UNESCO rule of law through education',
                    subtitle: 'UNESCO',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 3',
                    images: ['logo.png', 'logo2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/UNESCO%20rule%20of%20law%20through%20education?csf=1&web=1&e=3Dt35A',
                },
                {
                    id: 4,
                    title: 'UNICEF LACRO',
                    subtitle: 'UNICEF',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 4',
                    images: ['logo2.png', 'logo.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                },
                {
                    id: 5,
                    title: 'UNODC - Bolivia',
                    subtitle: 'Bolivia',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 5',
                    images: ['logo.png', 'logo2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                },
                {
                    id: 6,
                    title: 'UNODC - Brazil',
                    subtitle: 'Brazil',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 6',
                    images: ['logo2.png', 'logo.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                },
                {
                    id: 7,
                    title: 'UNODC - Mexico',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo.png', 'logo2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                },
            ],
        };  
    },
    methods: {
        descargarArchivo(nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte/${nombreArchivo}`;//local
            
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank'); // Para abrir el archivo en una nueva pestaña
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        descargarCategory(id, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte1/${id}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte1/${id}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosCategories(id) {
            try {
                const response = await axios.get(`api/Categories/MostrarCategories/${id}`);
                switch (id) {
                    case 1:
                        this.nombresAdjuntos = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntos2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntos3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntos4 = response.data;
                        break;
                    case 5:
                        this.nombresAdjuntos5 = response.data;
                        break;
                    case 6:
                        this.nombresAdjuntos6 = response.data;
                        break;
                    case 7:
                        this.nombresAdjuntos7 = response.data;
                        break;
                    case 8:
                        this.nombresAdjuntos8 = response.data;
                        break;
                    case 9:
                        this.nombresAdjuntos9 = response.data;
                        break;
                    case 10:
                        this.nombresAdjuntos10 = response.data;
                        break;
                    case 11:
                        this.nombresAdjuntos11 = response.data;
                        break;
                    case 12:
                        this.nombresAdjuntos12 = response.data;
                        break;
                    case 13:
                        this.nombresAdjuntos13 = response.data;
                        break;
                    case 14:
                        this.nombresAdjuntos14 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                return []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },
        
        /*
        async listar() {
            try {
                const response = await axios.get('api/Publication/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            return require(`../../assets/${filename}`);
        },
    },
    created() {
        const cardId = parseInt(this.$route.params.id);
        this.card = this.cards.find(card => card.id === cardId);
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 18px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
        padding-top: 0px;
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }
    .document-columns {
        columns: 2; /* Divide la lista en dos columnas */
        column-gap: 20px; /* Espacio entre las columnas */
    }
</style>